import { coerceBooleanProperty } from "@angular/cdk/coercion";
import {
  Directive,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from "@angular/core";
import { takeUntil } from "rxjs/operators";

import { CollapseAllService } from "./collapse-all.service";
import { FieldType } from "./constants";

@Directive()
export abstract class BaseJsonEditorComponent implements OnDestroy {
  FieldType = FieldType;

  @Input()
  rootName = "";

  @Input()
  isLastChild = false;

  @Input()
  get nested(): boolean {
    return this._nested;
  }
  set nested(val: boolean) {
    this._nested = coerceBooleanProperty(val);
  }
  private _nested = false;

  @Output()
  removeSelf = new EventEmitter();

  showNewControlForm = false;

  collapsed = true;

  protected constructor(collapseAllService: CollapseAllService) {
    collapseAllService.next
      .pipe(takeUntil(this.onDestroyEmitter))
      .subscribe((collapsed) => {
        this.collapsed = collapsed;
      });
  }

  toggleNewControlForm(): void {
    this.collapsed = false;
    this.showNewControlForm = !this.showNewControlForm;
  }

  toggleCollapsed(): void {
    this.showNewControlForm = false;
    this.collapsed = !this.collapsed;
  }

  getFieldType(value: any): FieldType {
    if (Array.isArray(value)) {
      return FieldType.Array;
    } else if (value instanceof Object) {
      return FieldType.Object;
    } else if (typeof value === "boolean") {
      return FieldType.Boolean;
    } else if (typeof value === "number") {
      return FieldType.Number;
    } else {
      return FieldType.String;
    }
  }

  protected onDestroyEmitter = new EventEmitter<void>();
  ngOnDestroy(): void {
    this.onDestroyEmitter.emit();
    this.onDestroyEmitter.complete();
  }

  getNewChildValue(child: any): any {
    switch (child.fieldType) {
      case FieldType.String:
      case FieldType.Number:
      case FieldType.Boolean:
        return child.value;
      case FieldType.Array:
        return [];
      case FieldType.Object:
        return {};
      case FieldType.RawJSON:
        return JSON.parse(child.value);
    }
  }
}
